import { UIHeading1 } from '@cian/ui-kit/typography';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { ReviewsSnippetStar } from '../ReviewsSnippetStar';

export interface IReviewsSnippetStarsProps {
  className?: string;
  isActive?: boolean;
  children?: React.ReactNode;
}

const starSize = 23;

export function ReviewsSnippetStars({ className, isActive = false, children }: IReviewsSnippetStarsProps) {
  if (!children) {
    return <ReviewsSnippetStar isActive={isActive} size={starSize} />;
  }

  return (
    <div className={cx(styles['rating'], className)}>
      <ReviewsSnippetStar isActive={isActive} size={starSize} />{' '}
      <span className={styles['text']}>
        <UIHeading1>{children}</UIHeading1>
      </span>
    </div>
  );
}
